<ng-container *ngIf="viewModel.fleet !='SNAPS'">
    <snl-page-tab [ngClass]="{'disabled': (viewModel.tab == 'all')}" [isSelected]="(viewModel.tab == 'all') ? true : false"
        (onPageTabClick)="clickOnPageTab('all')">
        All Ships <span></span>
        <snl-icon class="three-dot df-c" td__ellipsis icon="fa fa-ellipsis"></snl-icon>
    </snl-page-tab>
</ng-container>
<ng-container *ngFor="let subPool of subPools; let i=index">
    <snl-page-tab [isSelected]="(viewModel.tab == subPool.name) ? true : false" (onPageTabClick)="clickOnPageTab(subPool.name);$event.stopPropagation()">
        Sub Pool <span>
            {{subPool.name}}
        </span>
        <div class="subpool-action active" [ngClass]="{'active': viewModel.showSubpoolAction[i]}">
            <snl-icon class="three-dot df-c position-clx-{{i}}" td__ellipsis icon="fa fa-ellipsis" (click)="over($event,i);$event.stopPropagation()"></snl-icon >
            <div class='subpool-custom-dropdwn body-b1' id="subpool-submenu" [ngStyle]="{'top':viewModel.tempY+'px','left':viewModel.tempX+'px'}">
                <div class="d-flex col-gap-8" (click)="moreInformation(subPool,i);viewModel.showSubpoolAction[i] = false;$event.stopPropagation()">
                    <span><snl-icon class="add-sub-pool-icon" icon="fa fa-info"></snl-icon></span>
                    <span>Manage Sub Pool Data</span>
                </div>
                <div class="d-flex col-gap-8" (click)="showEditSubpool(subPool.name,i);viewModel.showSubpoolAction[i] = false;$event.stopPropagation(); showEdit($event)" >
                    <span><snl-icon class="add-sub-pool-icon" icon="fa-regular fa-pen-to-square"></snl-icon></span>
                    <span>Edit</span> 
                </div>
                <div class="d-flex col-gap-8" (click)="showDeleteSubpool(subPool.name,i);viewModel.showSubpoolAction[i] = false;$event.stopPropagation()"> <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.25 2.5C13.6562 2.5 14 2.84375 14 3.25C14 3.6875 13.6562 4 13.25 4H12.875L12.125 14.1562C12.0312 15.2188 11.1875 16 10.125 16H3.84375C2.78125 16 1.9375 15.2188 1.84375 14.1562L1.09375 4H0.75C0.3125 4 0 3.6875 0 3.25C0 2.84375 0.3125 2.5 0.75 2.5H2.90625L4.0625 0.78125C4.375 0.3125 4.9375 0 5.53125 0H8.4375C9.03125 0 9.59375 0.3125 9.90625 0.78125L11.0625 2.5H13.25ZM5.53125 1.5C5.4375 1.5 5.34375 1.5625 5.3125 1.625L4.71875 2.5H9.25L8.65625 1.625C8.625 1.5625 8.53125 1.5 8.4375 1.5H5.53125ZM11.375 4H2.59375L3.34375 14.0625C3.375 14.3125 3.59375 14.5 3.84375 14.5H10.125C10.375 14.5 10.5938 14.3125 10.625 14.0625L11.375 4Z" fill="#535353"/>
                        </svg>
                    <span>Delete</span>
                </div>
            </div>
        </div>
        <div class='subpool-new-custom-dropdwn body-b1' *ngIf="viewModel.showEditSubpoolBlock[i]" id="subpool-newCustom" [ngStyle]="{'top':viewModel.showEditSubpoolY+'px','left':viewModel.showEditSubpoolX+'px'}" >
            <form [formGroup]="editSubpoolFormGroup[i]" (click)="$event.stopPropagation()">
                <div class="d-flex align-items-center justify-content-between col-gap-8">
                    <div class="addsubpool">
                        <snl-input placeholder="Enter Sub Pool Name" label="Enter Sub Pool Name" maxlength="20" formControlName="name" [isError]="((editSubpoolFormGroup[i].controls['name'].hasError('required') || editSubpoolFormGroup[i].controls['name'].hasError('pattern')) && viewModel.submit)"></snl-input>
                    </div>
                    <div class="btn-pool aad" [ngClass]="{'disabled': editSubpoolFormGroup[i].value.name == viewModel.editSubPoolValue}" (click)="updateSubpool(subPool.name,i);$event.stopPropagation()">
                        <snl-icon class="" icon="fa-solid fa-check"></snl-icon>
                    </div>
                    <div class="btn-pool close" (click)="onPageEditTabClickClose(i);$event.stopPropagation()">
                       <snl-icon class="" icon="fa-solid fa-xmark"></snl-icon>
                    </div>
                </div>
            </form>
        </div>
    </snl-page-tab>
    
</ng-container>
<ng-container>
    <snl-page-tab class="add-section">
        <span (click)="onPageNewTabClick();addSubpoolClick($event)" class="position-clx-add-subpool">
            <snl-icon class="plus-icon df-c" icon="fa fa-plus"></snl-icon>
            <span class="add-sub-pool section-title color__primary_default" [ngClass]="{'active': viewModel.showAddNewSubpoolBlock}" > Add Sub Pool</span>
        </span>
        <div class='subpool-new-custom-dropdwn body-b1' [ngStyle]="{'top':viewModel.aadNewSubpoolY+'px','left':viewModel.addNewSubpoolX+'px'}" *ngIf="viewModel.showAddNewSubpoolBlock">
            <form [formGroup]="addSubpoolFormGroup">
                <div class="d-flex align-items-center justify-content-between col-gap-8">
                    <div class="addsubpool">
                        <snl-input label="Enter Sub Pool Name" placeholder="Enter Sub Pool Name"   maxlength="20" formControlName="name" [isError]="((addSubpoolFormGroup.controls['name'].hasError('required') || addSubpoolFormGroup.controls['name'].hasError('pattern')) && viewModel.submit)"></snl-input>
                    </div>
                    <div class="btn-pool aad" (click)="addNewSubpool()">
                        <snl-icon class="" icon="fa-solid fa-check"></snl-icon>
                    </div>
                    <div class="btn-pool close" (click)="onPageNewTabClick()">
                       <snl-icon class="" icon="fa-solid fa-xmark"></snl-icon>
                    </div>
                </div>
            </form>
        </div>
    </snl-page-tab>
</ng-container>
<!-- skeltion -->
<div class="subpool-Skelton-section">
    <div class="subpool-sektion"><span class="Skelton-pp"></span></div>
    <div class="subpool-sektion"><span class="Skelton-pp"></span></div>
    <div class="subpool-sektion"><span class="Skelton-pp"></span></div>
    <div class="subpool-sektion"><span class="Skelton-pp"></span></div>
    <div class="subpool-sektion"><span class="Skelton-pp"></span></div>
  </div> 
<!-- Delete Sub pool -->
<snl-modal class="model__customize delete-subpool" [settings]="setting" (modalClose)="viewModel.iDeleteSubpoolForm = false" [type]="'small'"
    [open]="viewModel.iDeleteSubpoolForm">
    <div slot="heading">Delete '{{viewModel.deleteSubPoolName}}'</div>
    <div slot="modalContent" class="body-b1">You are about to take an irreversible action.</div>
    <div slot="modalContent" class="body-b1">Are you sure ?</div>
    <div slot="modalFooter">
        <snl-button size="small" (buttonClick)="deleteSubPool()">Yes</snl-button>
        <snl-button size="small" type="secondary" (buttonClick)="viewModel.iDeleteSubpoolForm = false">No</snl-button>
    </div>
</snl-modal>

<snl-modal class="model__customize delete-move-ship" (modalClose)="viewModel.iDeleteSubpoolMoveForm = false" [settings]="setting" [type]="'medium'"
    [open]="viewModel.iDeleteSubpoolMoveForm">
    <div slot="heading">Delete Sub Pool {{viewModel.deleteSubPoolName}}</div>
    <div slot="modalContent" class="body-b1">
        There are <span *ngIf="viewModel.activeSubPoolsCount>0">{{viewModel.activeSubPoolsCount}} active ship{{(viewModel.activeSubPoolsCount>1)?'s':''}}</span>
        <span *ngIf="viewModel.activeSubPoolsCount>0 && viewModel.inactiveSubPoolsCount>0"> & </span>
        <span *ngIf="viewModel.inactiveSubPoolsCount>0">{{viewModel.inactiveSubPoolsCount}} inactive ship{{(viewModel.inactiveSubPoolsCount>1)?'s':''}}</span>
        in Sub Pool {{viewModel.deleteSubPoolName}}.
    </div>
    <div slot="modalContent" class="body-b1" style="margin-top: 24px;">Please move the ship{{(viewModel.inactiveSubPoolsCount+viewModel.activeSubPoolsCount>1)?'s':''}} to other Sub Pool in order to delete Sub Pool {{viewModel.deleteSubPoolName}}.</div>
    <div slot="modalContent">
        <div class="d-flex" *ngIf="viewModel.iDeleteSubpoolMoveForm">
            <div class="half-containers form-field">
                <div class="CustomizeInput dropdown-customize">
                    <label class="body-b labels color__primary">Select Sub Pool</label>
                    <ng-select class="btm-border-select" [items]="viewModel.suggestedSubpools" [(ngModel)]="viewModel.moveSubpoolName"
                        [searchable]="false">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <span [innerHTML]="item"></span>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
        </div>
    </div>
    <div slot="modalFooter">
        <snl-button size="small" (buttonClick)="moveShipToSubpool()">Save</snl-button>
        <snl-button size="small" type="secondary" (buttonClick)="viewModel.iDeleteSubpoolMoveForm = false">Cancel</snl-button>
    </div>
</snl-modal>

<div *ngIf="viewModel.iManageSubpool">
    <snl-modal  class="model__customize manage-subpool" [settings]="setting"  [type]="'small'" [open]="viewModel.iManageSubpool">
        <div slot="heading">Sub Pool {{viewModel.editSubPoolValue}} Details </div>
        <div slot="modalContent" class="body-b1">
            <div class="discription activity-log" *ngIf="!viewModel.iManageSubpoolAdd">
                <div class="d-flex align-items-center col-gap-14 form">
                    <span class="body-b3 fw-400 color__secondary">
                        <div class="dropdown-col _TextFltr _TextDurations scroll">
                            <ng-select class="btm-border-select" 
                                [items]="viewModel.subPoolsDurations"
                                [(ngModel)]="viewModel.selectedAttributes"
                                (change)="changeDurations($event)"
                                [searchable]="false"> 
                                <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                let-index="index">  
                                <span [innerHTML]="item.label"  ></span>
                                </ng-template> 
                            </ng-select>
                        </div>
                        
                    </span>
                </div>
            </div>
            <form [formGroup]="subPoolManageForm">
                <snl-table class="account-scrubber-list">
                    <snl-row>
                      <snl-th><span class="color__primary">Month</span></snl-th>
                      <snl-th class="h-right"><span class="color__primary">Accounting Voyage ($)</span></snl-th>
                      <snl-th class="h-right"><span class="color__primary">Scrubber Savings ($)</span></snl-th>
                    </snl-row>
                    <snl-row *ngFor="let subpoolsMonthly of viewModel.subpoolsMonthlyList">
                        <snl-td>  
                            <span class="color__primary">{{poolmonth(subpoolsMonthly.month)}} {{subpoolsMonthly.year}}</span>
                        </snl-td>
                        <snl-td textStyle="right">  
                            <span class="color__primary">{{subpoolsMonthly.accountingVoyage | number : '1.2-2'}}</span>
                        </snl-td>
                        <snl-td textStyle="right">  
                            <span class="color__primary">{{subpoolsMonthly.scrubberSavings | number : '1.2-2'}}</span>
                        </snl-td> 
                    </snl-row>
                    <snl-row *ngIf="viewModel.iManageSubpoolAdd">
                        <snl-td><span class="color__primary">{{lastMonthDate('month')}} {{lastMonthDate('year')}}</span></snl-td>
                        <snl-td>
                            <div class="input-section">
                                <snl-input placeholder="" label="" formControlName="accountingVoyage" [isError]="((subPoolManageForm.controls['accountingVoyage'].hasError('required') || subPoolManageForm.controls['accountingVoyage'].hasError('pattern')) && viewModel.manageSubpoolSubmit)"  [isTrailingIconDisplayed]="true" trailingIcon="fa-dollar-sign far"></snl-input>
                            </div>
                        </snl-td>
                        <snl-td>
                            <div class="input-section">
                                <snl-input [isTrailingIconDisplayed]="true" trailingIcon="fa-dollar-sign far" placeholder="" label="" formControlName="scrubberSavings" [isError]="(subPoolManageForm.controls['scrubberSavings'].hasError('required') && viewModel.manageSubpoolSubmit)" ></snl-input>
                            </div>
                        </snl-td>
                    </snl-row>
                </snl-table>
            </form>
        </div>
        <div slot="modalFooter">
            <snl-button size="small" (buttonClick)="viewModel.iManageSubpoolAdd = true" *ngIf="!viewModel.iManageSubpoolAdd" [disabled]="disabledManageSubPool()">Add</snl-button>
            <snl-button size="small" *ngIf="viewModel.iManageSubpoolAdd" (buttonClick)="submitManageSubPool()">Save</snl-button>
            <snl-button size="small" type="secondary" (buttonClick)="closeManageSubpool()">Cancel</snl-button>
        </div>
    </snl-modal>
</div>



